module.exports = __webpack_public_path__ + "static/media/circle-very-high.f0bceff1.svg";